import dayjs from 'dayjs';
import * as relativeTime from 'dayjs/plugin/relativeTime';
import * as timezone from 'dayjs/plugin/timezone';
import * as utc from 'dayjs/plugin/utc';
dayjs.extend(relativeTime);
dayjs.extend(timezone);
dayjs.extend(utc);

export function getNewYorkTimeZoneDate(optionalDate) {
  return dayjs(optionalDate).tz('America/New_York');
}

export function getUTCDate(optionalDate) {
  return dayjs(optionalDate).utc();
}
